import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { tourPackageTtkSchema } from '../schemas';
import axios from "axios";
import { NumericFormat } from 'react-number-format';
import ThinksToKnowStatus from './ThinksToKnowStatus';

const TourPackageTTK = () => {
    const [ttkEditMode, setTtkEditMode] = useState(false)
    const { user, language, token, currency } = useUserAuth();
    const merchant_id = user.uid;
    const [merchant, setMerchant] = useState({});
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])

    const workingSinceOption = checkboxData.workSinceOption;
    const durationTypeOption = checkboxData.durationType;
    const travelPreferenceFlorish = checkboxData.travelPreferenceFlorish;
    const travellingTypeOption = checkboxData.travellingType;
    const tourProvidedoption = checkboxData.tourProvided;

    const formik = useFormik({
        initialValues: {
            price: Math.floor(merchant?.price * currency.value) || '',
            workingSince: merchant?.workingSince || [],
            durationType: merchant?.durationType || [],
            travelPreference: merchant?.travelPreference || [],
            travellingType: merchant?.travellingType || [],
            tourProvided: merchant?.tourProvided || [],
        },
        enableReinitialize: true,
        validationSchema: tourPackageTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values, price: Math.floor(values.price * currency.country_value) },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header bg-primary text-white'>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Tour Duration</th>
                                                            <th style={{ width: '25%' }}>Travel Preference</th>
                                                            <th style={{ width: '25%' }}>Travelling Vehicle Type</th>

                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <span key={index}>{item.value}</span>
                                                                })
                                                            }</td>
                                                            <td>{
                                                                merchant.durationType
                                                                    ?.map((item, index) => {
                                                                        return (<span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>)
                                                                    })
                                                            }</td>

                                                            <td>{
                                                                merchant.travelPreference
                                                                    ?.map((item, index) => {
                                                                        return (<span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>)
                                                                    })
                                                            }</td>

                                                            <td>{
                                                                merchant.travellingType
                                                                    ?.map((item, index) => {
                                                                        return (<span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>)
                                                                    })
                                                            }</td>
                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Tour Provided in areas</th>
                                                            <th>Price</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.tourProvided
                                                                    ?.map((item, index) => {
                                                                        return (<span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>)
                                                                    })
                                                            }</td>
                                                            <td>
                                                                <NumericFormat
                                                                    value={Math.floor(
                                                                        currency.value * merchant.price
                                                                    )}
                                                                    displayType="text"
                                                                    thousandsGroupStyle={
                                                                        currency.symbol === "₹" ? "lakh" : "thousand"
                                                                    }
                                                                    thousandSeparator=","
                                                                    renderText={(formattedValue) => (
                                                                        <span>
                                                                            {currency.symbol}&nbsp;{formattedValue}
                                                                        </span>
                                                                    )}
                                                                /></td>

                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn btn-primary mb-2' onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>

                                                </div>


                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Tour Duration<span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={durationTypeOption}
                                                            selected
                                                            value={formik.values.durationType}
                                                            onChange={(durationType) => formik.setFieldValue('durationType', durationType)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.durationType && formik.errors.durationType ? (
                                                            <div className="text-danger">{formik.errors.durationType}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Travel Preference</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={travelPreferenceFlorish}
                                                            selected
                                                            value={formik.values.travelPreference}
                                                            onChange={(travelPreference) => formik.setFieldValue('travelPreference', travelPreference)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.travelPreference && formik.errors.travelPreference ? (
                                                            <div className="text-danger">{formik.errors.travelPreference}</div>
                                                        ) : null}
                                                    </div>
                                                </div>


                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Travelling Vehicle Type</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={travellingTypeOption}
                                                            selected
                                                            value={formik.values.travellingType}
                                                            onChange={(travellingType) => formik.setFieldValue('travellingType', travellingType)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.travellingType && formik.errors.travellingType ? (
                                                            <div className="text-danger">{formik.errors.travellingType}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Tour Provided in Areas</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={tourProvidedoption}
                                                            selected
                                                            value={formik.values.tourProvided}
                                                            onChange={(tourProvided) => formik.setFieldValue('tourProvided', tourProvided)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.tourProvided && formik.errors.tourProvided ? (
                                                            <div className="text-danger">{formik.errors.tourProvided}</div>
                                                        ) : null}
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <label class="" for="inlineFormInputGroup">Starting Price<span className="text-danger">*</span></label>
                                                    <div class="input-group mb-2">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input type="number"
                                                            placeholder="Services Starts At"
                                                            className="form-control"
                                                            name="price"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.price} />
                                                    </div>
                                                    {formik.touched.price && formik.errors.price ? (
                                                        <div className="text-danger">
                                                            {formik.errors.price}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <button className='btn btn-primary' type='submit'>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default TourPackageTTK